var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "onboarding-loading-overlay" }, [
        _c("div", { staticClass: "onboarding-loading-spinner" }, [
          _c("div", { staticClass: "spinner" }),
          _c("span", { staticClass: "loading-percent" }, [
            _vm._v(_vm._s(_vm.simulatedProgress) + "%"),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }